import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AlertDialog({ open, setOpen, artworkUrl }) {
  return (
    <Dialog open={open} onClose={setOpen}>
      <DialogTitle>Art Preview</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <img src={artworkUrl} alt='artwork' style={{ width: '100%' }} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={setOpen} color='primary'>
          Ok
        </Button>
        <Button onClick={() => window.open(artworkUrl)} color='primary'>
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
}
